// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"ef7f3486","1186":"22eb790f","4485":"4e489f7b","6243":"626a9a7d"}[chunkId] + ".chunk.css";
};